import { render, staticRenderFns } from "./ShareList.vue?vue&type=template&id=35f963dd&scoped=true&"
import script from "./ShareList.vue?vue&type=script&lang=js&"
export * from "./ShareList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f963dd",
  null
  
)

export default component.exports